import { useActivePhoto, useSetActivePhoto } from '@context/ActivePhotoContext'
import ImageWrapper from '@components/image/WrapperFilling'
import AdvancedImage from '@components/image/WithFallback'
import Icon from '@components/shared/Icon'
import styles from 'styles/display/Lightbox.module.css'
import Thumbnails from './Thumbnails'
import Video from '@components/display/video/Video'
import fullPhoto from '@utils/links/fullPhoto'
import withBreakpoints from '@hoc/withBreakpoints'
import { defaultTouchHandlerProps } from './touchEvents'

function Lightbox ({ photos, pid, toggle, video,
    breakpoints: { mobile }}) {

    return (
        <div className={styles.lightbox}>
            <div className={styles.container}>
                <div className={styles['control-tier']}>
                    <span className={styles.control} onClick={toggle}><Icon>close</Icon></span>
                </div>

                <div className={styles['viewable-tier']}>
                    <PhotoOrVideo pid={pid} video={video} />
                </div>

                <div className={styles['control-tier']}>
                    <Controls max={(photos?.length - 1) || 0} min={(video ? -1 : 0)} />
                </div>

                { !mobile && <div className={styles['thumbnail-tier']}>
                    <Thumbnails offer={{photos,tracking:{pid}}} />
                </div> }
            </div>
        </div>
    )
}

function PhotoOrVideo ({ pid, video }) {
    const viewableIdx = useActivePhoto()

    return viewableIdx === -1
        ? <Video offer={{ video_link: video }} />
        : <ImageWrapper>
            <AdvancedImage {...defaultTouchHandlerProps}
                draggable={false}
                layout="fill"
                objectFit="contain"
                src={fullPhoto(pid, viewableIdx)} />
          </ImageWrapper>
}

function Controls ({ max, min }) {
    if (max <= min) return null

    const currIdx = useActivePhoto()
    const setActivePhoto = useSetActivePhoto()

    const prev = () => {
        const move = currIdx - 1
        setActivePhoto((move >= min ? move : max))
    }

    const next = () => {
        const move = currIdx + 1
        setActivePhoto((move <= max ? move : min))
    }

    return (
        <div className={styles.controls}>
            <span onClick={prev} id="move-left"><Icon>chevron_left</Icon></span>
            <span onClick={next} id="move-right"><Icon>chevron_right</Icon></span>
        </div>
    )
}

export default withBreakpoints({ mobile: 1000 })(Lightbox)
export {
    Controls,
}

